import { axiosInstance } from "./axiosConfig";
import { NetworkError } from "./runQueryFn";
import { isActiveToken } from "../utils/session/authorizationToken";

const AUTH_REQUEST_TIMEOUT_MS = 60_000;

export const AUTH_MESSAGES = {
  phone: "Не удалось отправить код, попробуйте ещё раз или зайдите чуть позже.",
  sms: "Не удалось проверить код, попробуйте ещё раз или зайдите чуть позже.",
  passport: "Ошибка при проверке данных, попробуйте позже",
  pin: "Не удалось выполнить запрос. Попробуйте ещё раз",
  incorrect: "Неверный код",
};

export const isIdentifier = (value: unknown): value is string => typeof value === "string" && value.trim().length > 0;

// Same baseURL/channel as the data API; auth requests bypass its token interceptor.
export async function newAuthRequest(path: string, body?: object, method = "POST", token?: string, signal?: AbortSignal) {
  const base = (axiosInstance.defaults.baseURL ?? "/api").replace(/\/+$/, "");
  const prefix = base.endsWith("/v1") ? "" : "/v1";
  const controller = new AbortController();

  const abort = () => {
    controller.abort();
  };

  if (signal?.aborted) {
    abort();
  }

  signal?.addEventListener("abort", abort);
  const timeout = setTimeout(abort, AUTH_REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(`${base}${prefix}${path}`, {
      method,
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        "X-Channel-Id": "web",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    const text = await response.text();
    if (!response.ok) {
      throw new NetworkError(response.status, text);
    }

    try {
      const data: unknown = JSON.parse(text);
      return data && typeof data === "object" ? data as Record<string, unknown> : {};
    } catch (_error) { return {}; }
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener("abort", abort);
  }
}

export function validateCredentials(data: Record<string, unknown>, requireDevice = true) {
  if (!isActiveToken(data.token) || !isIdentifier(data.refreshToken) || (requireDevice && !isIdentifier(data.deviceId))) {
    throw new Error(AUTH_MESSAGES.pin);
  }

  return {
    token: data.token,
    refreshToken: data.refreshToken,
    deviceId: isIdentifier(data.deviceId) ? data.deviceId : undefined,
  };
}

export function pinError(error: unknown) {
  return error instanceof NetworkError && error.status === 461 && error.internalCode === 7001
    ? AUTH_MESSAGES.incorrect
    : AUTH_MESSAGES.pin;
}
